
import React from 'react'
//import makeStyles from '@material-ui/core/styles/makeStyles'

export default function ClockIcon(props) {
    const { style, color } = props;
    //const classes = useStyles(props)()

    return(
        <svg style={style} width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={color} d="M11.5 0C17.8595 0 23 5.152 23 11.5C23 17.8595 17.8595 23 11.5 23C5.152 23 0 17.8595 0 11.5C0 5.152 5.152 0 11.5 0ZM11.0975 5.6695C10.626 5.6695 10.235 6.049 10.235 6.532V12.3395C10.235 12.6385 10.396 12.9145 10.6605 13.0755L15.1685 15.7665C15.3065 15.847 15.456 15.893 15.617 15.893C15.9045 15.893 16.192 15.7435 16.353 15.4675C16.5945 15.065 16.468 14.536 16.054 14.283L11.96 11.845V6.532C11.96 6.049 11.569 5.6695 11.0975 5.6695Z" />
        </svg>

    )
}